module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-event-listener/~/babel-runtime/core-js/object/define-property.js
 ** module id = 798
 ** module chunks = 3
 **/